import { useLocation } from 'react-router-dom';

import { getTabRoute } from '@/entities/MobileDocumentTabs/config';
import { TabKey } from '@/entities/MobileDocumentTabs/types';

const TAB_KEYS: TabKey[] = [TabKey.documentPreview, TabKey.aiSummary, TabKey.analyze, TabKey.properties];

export const useActiveTab = (organizationId: number, documentId?: string) => {
  const { pathname } = useLocation();

  if (!documentId) {
    return null;
  }

  const activeTab = TAB_KEYS.find((tab) => pathname.includes(getTabRoute(tab, organizationId, documentId)));

  return activeTab ?? null;
};
